module.exports = __webpack_public_path__ + "media/images/swb_logo_fact_sheet-7b0b2cdc8d6f621358659b2fd93bfe6c.png";